import { AdgroupFormData, CampaignFormData, PlatformType } from '@tt4b/ttam-enums';
import { Ref, ref, computed } from '@vue/composition-api';
import { i18n } from './../../../i18n';
import { useStdAdgroupIs, useStdObjectiveType } from '@tt4b/ttam-hooks';

export function usePlatformOPtions(opt: { iOSPlatformDisabled: Ref<boolean> }) {
  const { iOSPlatformDisabled } = opt;
  const PLATFORM_OPTIONS = [
    {
      name: i18n.t('adgroup_no_limit'),
      value: PlatformType.NO_LIMIT,
    },
    {
      name: 'iOS',
      value: PlatformType.IOS,
      disabled: iOSPlatformDisabled.value,
    },
    {
      name: 'Android',
      value: PlatformType.ANDROID,
    },
  ];
  const platformOptions = ref(PLATFORM_OPTIONS);
  return {
    platformOptions,
  };
}

export function usePlatformName(platform: Ref<PlatformType>) {
  const { platformOptions } = usePlatformOPtions({
    iOSPlatformDisabled: ref(false),
  });

  const platformName = computed(() => {
    const platformMap = {
      0: i18n.t('adgroup_no_limit'),
      1: 'Android',
      2: 'iOS',
    };
    return platformMap[platform.value];
  });

  return {
    platformName,
  };
}

export function useOperatingSystemVisible(opt: {
  adgroupData: Ref<AdgroupFormData>;
  campaignData: Ref<CampaignFormData>;
}) {
  const { adgroupData, campaignData } = opt;
  // objective：Product Sales; adType: 非Live; productSource: shop/catalog-web
  const { isProductSales } = useStdObjectiveType({ campaignFormData: campaignData });
  const {
    isStandardAdsWithShop,
    isStandardAdsWithShowcase,
    isStandardAdsWithCatalog,
    isWebsite,
    isLiveAds,
  } = useStdAdgroupIs({
    adgroupFormData: adgroupData,
    campaignFormData: campaignData,
  });
  const operatingSystemVisible = computed(
    () =>
      isProductSales.value &&
      (isStandardAdsWithShop.value ||
        isLiveAds.value ||
        isStandardAdsWithShowcase.value ||
        (isStandardAdsWithCatalog.value && isWebsite.value)),
  );
  return {
    operatingSystemVisible,
  };
}
